import { Instance, types } from 'mobx-state-tree';

import { getAdmin, removeAdmin, saveAdmin } from '@common/api/admins';
import User from '@common/models/Users/User';

const Admin = types
	.compose(
		User,
		types.model({
			services_ids: types.optional(types.array(types.number), []),
			locations_ids: types.optional(types.array(types.number), []),
		}),
	)
	.named('Admin')
	.actions(() => ({
		_fetch: getAdmin,
		_save: saveAdmin,
		_remove: removeAdmin,
	}));

export default Admin;

export interface IAdminModel extends Instance<typeof Admin> {}
